import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/** Destination hospital fields — city locked for in-station (Hyderabad). */
export default function SeekingHospitalFields({
  form, setForm, specialisations, stationType = 'in_station',
}) {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const cityLocked = stationType === 'in_station';

  return (
    <section className="space-y-4">
      <div>
        <h2 className="font-heading text-xl text-stone-900">Hospital / Clinic Seeking Referral</h2>
        <p className="text-sm text-stone-500">Where should the specialist letter be addressed?</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <Label>Hospital or clinic name (optional)</Label>
          <Input
            className="mt-1 bg-white"
            placeholder="e.g. Apollo Hospitals, Jubilee Hills"
            value={form.hospital_clinic || ''}
            onChange={(e) => set('hospital_clinic', e.target.value)}
          />
        </div>
        <div>
          <Label>Specialisation *</Label>
          <Select value={form.specialisation || ''} onValueChange={(v) => set('specialisation', v)}>
            <SelectTrigger className="mt-1 bg-white">
              <SelectValue placeholder="Select specialisation" />
            </SelectTrigger>
            <SelectContent className="max-h-72">
              {(specialisations || []).map((s) => (
                <SelectItem key={s} value={s}>{s}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>City{cityLocked ? '' : ' *'}</Label>
          <Input
            className={`mt-1 bg-white ${cityLocked ? 'cursor-not-allowed bg-stone-50 text-stone-600' : ''}`}
            placeholder={cityLocked ? 'Hyderabad' : 'Enter city'}
            value={form.city || ''}
            readOnly={cityLocked}
            disabled={cityLocked}
            onChange={(e) => set('city', e.target.value)}
            data-testid="seeking-city"
          />
          {cityLocked ? (
            <p className="mt-1 text-[11px] text-stone-500">In-station referrals use Hyderabad.</p>
          ) : null}
        </div>
        <div className="sm:col-span-2">
          <Label>Clinical reason for referral *</Label>
          <Textarea
            className="mt-1 min-h-[110px] bg-white"
            placeholder="Describe symptoms, prior treatment, and why specialist care is needed…"
            value={form.reason || ''}
            onChange={(e) => set('reason', e.target.value)}
          />
        </div>
      </div>
    </section>
  );
}
